import cx from 'classnames';

import style from './LogoLoader.module.css';

export function LogoLoader({ className }: { className?: string }) {
    return (
        <svg className={cx(style.icon, className)} width="76" height="76" viewBox="0 0 107 107">
            <path
                d="M87.9624 14.4281C69.2349 -2.11773 40.5516 -2.14266 21.7867 14.3533C8.01824 26.4603 2.56071 44.1408 5.40162 60.6741C9.4387 84.0902 2.44856 103.728 2.02492 104.95V104.975L2 105L2.03738 104.963C3.25847 104.539 22.8707 97.5438 46.2708 101.584C61.8086 104.264 78.3308 99.626 90.3049 87.6312C110.652 67.27 109.867 33.7794 87.9624 14.4281Z"
                strokeLinejoin="round"
            />
            <path d="M76.3282 29.5029C63.9034 17.7238 44.2823 18.2473 32.5032 30.6721C20.7241 43.0969 21.2476 62.7181 33.6724 74.4971C46.0972 86.2762 65.7184 85.7527 77.4974 73.3279" />
        </svg>
    );
}
